import { Counter } from "@/components/inputs/Counter.tsx";
import { styled } from "@linaria/react";
import { useUserStore } from "@/stores/useUserStore.ts";
import { useEffect } from "react";
import { putTutorCapacity } from "@/api/tutors.ts";
import { toastAndError } from "@/helpers/toast.ts";
import { useDebouncedCallback } from "@tanstack/react-pacer";

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
`;

const Text = styled.span`
  // Disable select as to not steal focus from counter
  user-select: none;
`;

export const CounterNavCapacity = () => {
  const { SetCapacity, settings } = useUserStore();
  const debounce = useDebouncedCallback(
    (newCapacity: number) => {
      putTutorCapacity(newCapacity).catch((e) => {
        toastAndError("Could not update capacity", e);
      });
    },
    {
      wait: 1000,
    },
  );

  useEffect(() => {
    debounce(settings.capacity);
  }, [debounce, settings.capacity]);

  return (
    <Wrapper
      data-tooltip={
        "This sets the maximum number of students that can be allocated to you at a given moment"
      }
      data-direction={"bottom"}
    >
      <Text>My capacity</Text>
      <Counter
        state={settings.capacity}
        min={1}
        onChange={(newCount) => {
          SetCapacity(newCount);
        }}
        id={"Capacity counter"}
      />
    </Wrapper>
  );
};
